function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
import * as React from 'react';
import SvgButton from "../../basic/SvgButton";
import { color, font, zIndex, spacing } from "../../../styles/theme";
import { SvgArrowLeft } from "../../../svg";
import { lighten } from "../../../utils/colorUtils";
var BUTTON_SIZE = 72; // px

var BUTTON_BG_COLOR = lighten(color.black, 0.1); // TODO: use '#202F3A' once design consolidates

var CONFIG = {
  TunnelVisionClose: {
    'display': 'inline-block',
    'backgroundColor': BUTTON_BG_COLOR,
    'height': BUTTON_SIZE,
    'width': BUTTON_SIZE,
    'overflow': 'hidden',
    'cursor': 'pointer',
    'border': 'none',
    'borderRadius': 0,
    'padding': 0,
    ':hover': {
      backgroundColor: BUTTON_BG_COLOR,
      border: 'none'
    }
  },
  tunnelVisionCloseTooltip: function tunnelVisionCloseTooltip(closeButtonAlignment) {
    return {
      ':after': _objectSpread({
        content: '"Back to Content"',
        color: color.white,
        background: lighten(color.black, 0.2),
        padding: spacing.sm,
        position: 'fixed'
      }, closeButtonAlignment === 'right' ? {
        right: 0
      } : {
        left: '-9999px'
      }, {
        opacity: 0,
        bottom: '100%',
        whiteSpace: 'nowrap',
        transition: 'opacity .15s ease-in-out',
        fontSize: font.sm,
        minWidth: BUTTON_SIZE
      }),
      ':hover:after': _objectSpread({}, closeButtonAlignment === 'right' ? {
        right: 0
      } : {
        left: 0
      }, {
        top: BUTTON_SIZE,
        opacity: 1,
        zIndex: zIndex.xl,
        height: 36,
        pointerEvents: 'none'
      })
    };
  }
};

var TunnelVisionClose = function TunnelVisionClose(_ref) {
  var closeElement = _ref.closeElement,
      showTooltip = _ref.showTooltip,
      handleClose = _ref.handleClose,
      backbuttonAriaLabel = _ref.backbuttonAriaLabel,
      closeButtonAlignment = _ref.closeButtonAlignment;
  var customStyles = {
    Button: CONFIG.TunnelVisionClose
  };

  if (showTooltip) {
    // merge tooltip styles
    customStyles.Button = Object.assign({}, customStyles.Button, CONFIG.tunnelVisionCloseTooltip(closeButtonAlignment));
  }

  return React.createElement(SvgButton, {
    rootClassName: "rc-TunnelVisionClose",
    onClick: handleClose,
    type: "noStyle",
    svgElement: closeElement || React.createElement(SvgArrowLeft, {
      color: color.white,
      size: BUTTON_SIZE / 1.5
    }),
    customStyles: customStyles,
    htmlAttributes: {
      'aria-label': backbuttonAriaLabel || 'Close Tunnel Vision',
      'data-classname': 'TunnelVisionClose',
      'name': 'Tunnel Vision Close'
    }
  });
};

export default TunnelVisionClose;